import store from "../store";

export default function (
  state = { websocket: {}, message: {}, apiLocation: "" },
  action
) {
  switch (action.type) {
    case "SEND_MESSAGE":
      state.websocket.send(JSON.stringify(action.message));
      return Object.assign({}, state, {});
    case "OPEN_WEBSOCKET":
      var token = action.token;
      var tokenURIString = "";
      let socket = null;
      if (token) {
        tokenURIString = "token=" + token;
        socket = new WebSocket(
          "wss://" + action.apiLocation + "/kps/news?" + tokenURIString
        );
        socket.addEventListener("message", function (e) {
          store.dispatch({
            type: "SET_MESSAGE",
            message: e.data,
          });
        });
        socket.addEventListener("close", function (e) {
          var messageObject = { type: "error", message: "Need login" };
          store.dispatch({
            type: "SET_MESSAGE",
            message: JSON.stringify(messageObject),
          });
        });
        state.websocket = socket;
      }
      return Object.assign({}, state, {
        websocket: socket,
        apiLocation: action.apiLocation,
      });
    case "CLOSE_WEBSOCKET":
      state.websocket.close();
      return state;
    case "OPEN_WEBSOCKET_LOGIN":
      var username = action.login.username;
      var password = action.login.password;
      var loginString = "username=" + username + "&password=" + password;
      let socket2 = new WebSocket(
        "wss://" + action.apiLocation + "/kps/news?" + loginString
      );
      socket2.addEventListener("message", function (e) {
        store.dispatch({
          type: "SET_MESSAGE",
          message: e.data,
        });
      });
      socket2.addEventListener("close", function (e) {
        var messageObject = { type: "error", message: "Need login" };
        store.dispatch({
          type: "SET_MESSAGE",
          message: JSON.stringify(messageObject),
        });
      });
      state.websocket = socket2;
      return Object.assign({}, state, {});
    case "SET_MESSAGE":
      var message = JSON.parse(action.message);
      if (message.type === "com.kpsol.api.apicommon.theme.ThemeInterface") {
        return Object.assign({}, state, {});
      } else {
        return Object.assign({}, state, {
          message: message,
        });
      }
    default:
      return state;
  }
}
